import axios from "axios";

export const getAiApiUrl = () =>
  (process.env.REACT_APP_AI_API_URL || "https://dsf-api.classicprogrammers.com/ai").replace(
    /\/+$/,
    ""
  );

export const PAGE_ACTIONS = [
  { label: "Undo", message: "undo" },
  { label: "Reset to defaults", message: "reset to defaults" },
  { label: "Show my changes", message: "show my changes" },
  { label: "What can you change", message: "what can you change?" },
];

export const getCardView = (pending) => {
  if (!pending || typeof pending !== "object") return null;
  if (pending.action || pending.title || pending.before || pending.after || pending.explain) {
    return pending;
  }
  if (pending.card && typeof pending.card === "object") return pending.card;
  return pending;
};

export const getCardAction = (pending) => String(getCardView(pending)?.action || "").toLowerCase();

export const formatTrainerValue = (value) => {
  if (value == null || value === "") return "";
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  if (Array.isArray(value)) {
    return value.map((item, index) => `${index + 1}. ${formatTrainerValue(item)}`).join("\n");
  }
  if (typeof value !== "object") return String(value);

  if (value.en != null || value.fr != null) {
    return [value.en != null && `EN: ${value.en}`, value.fr != null && `FR: ${value.fr}`]
      .filter(Boolean)
      .join("\n");
  }
  if (value.preceding != null || value.client != null || value.coach != null) {
    return [
      value.preceding != null && `Preceding: ${formatTrainerValue(value.preceding)}`,
      value.client != null && `Client: ${formatTrainerValue(value.client)}`,
      value.coach != null && `Coach: ${formatTrainerValue(value.coach)}`,
    ]
      .filter(Boolean)
      .join("\n");
  }
  if (value.text != null || value.category != null) {
    return [value.category != null && `Category: ${value.category}`, value.text]
      .filter((item) => item != null && item !== "")
      .join("\n");
  }
  if (value.count != null) return String(value.count);
  if (Array.isArray(value.notes)) return formatTrainerValue(value.notes);
  if (value.setting != null) return formatTrainerValue(value.setting);

  return Object.entries(value)
    .map(([key, nested]) => `${key}: ${formatTrainerValue(nested)}`)
    .join("\n");
};

const unwrapPayload = (data) => {
  if (!data || typeof data !== "object") return {};
  const nested = data.data;
  if (
    nested &&
    typeof nested === "object" &&
    ("reply" in nested || "pending" in nested || "reply_short" in nested)
  ) {
    return nested;
  }
  return data;
};

export const sendTrainerChat = async (message, pending = null) => {
  const apiBaseUrl = getAiApiUrl();

  try {
    const response = await axios.post(`${apiBaseUrl}/admin/trainer/chat`, {
      message,
      pending: pending ?? null,
    });
    const payload = unwrapPayload(response?.data);

    return {
      reply: String(payload.reply || "").trim() || "No reply received.",
      replyShort: String(payload.reply_short || "").trim(),
      pending: Object.prototype.hasOwnProperty.call(payload, "pending")
        ? payload.pending
        : pending ?? null,
      applied: Boolean(payload.applied),
      settingsVersion: payload.settings_version ?? null,
      error: false,
    };
  } catch (error) {
    const status = error?.response?.status;
    const payload = unwrapPayload(error?.response?.data);
    const apiMessage =
      payload.reply ||
      payload.message ||
      payload.error ||
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      "";

    let reply = apiMessage;
    if (status === 401) {
      reply = apiMessage || "Your session expired. Please sign in again.";
    } else if (status === 403) {
      reply = apiMessage || "You need Administrator access to use Live Coaching.";
    } else if (status === 500) {
      reply = apiMessage || "The trainer service had an error. Please try again.";
    } else if (!reply) {
      reply = "Could not reach the trainer service. Please try again.";
    }

    return {
      reply,
      replyShort: "",
      pending: pending ?? null,
      applied: false,
      settingsVersion: null,
      error: true,
    };
  }
};
